import { switchMap as switchMap$1, mergeMap as mergeMap$1, map as map$1 } from "rxjs/operators";
import { applyLocationAttrs } from "./OtelSpan.js";
import { TracingService } from "./TracingService.js";
function hasType(obj) {
  return typeof obj === "object" && obj !== null && "type" in obj;
}
const ReduxMiddlewareAttributes = {
  REDUX_ACTION: "redux.action"
};
function applyReduxAttrs(span, action) {
  span?.setAttributes({
    [ReduxMiddlewareAttributes.REDUX_ACTION]: action
  });
}
const spanName = "REDUX ACTION";
function switchMap(project) {
  return switchMap$1((val, index) => {
    let result = void 0;
    const action = hasType(val) ? val.type : null;
    const tracingService = new TracingService();
    const tracer = tracingService.getTracer();
    if (action && tracer) {
      try {
        const result2 = project(val, index);
        return result2;
      } catch (e) {
        const message = e.toString();
        const span = tracer.startSpan(spanName);
        applyLocationAttrs(span);
        applyReduxAttrs(span, action);
        tracingService.endSpanFailed(span, message);
        throw new Error(e);
      }
    } else {
      result = project(val, index);
    }
    return result;
  });
}
function mergeMap(project) {
  return mergeMap$1((val, index) => {
    let result = void 0;
    const action = hasType(val) ? val.type : null;
    const tracingService = new TracingService();
    const tracer = tracingService.getTracer();
    if (action && tracer) {
      try {
        const result2 = project(val, index);
        return result2;
      } catch (e) {
        const message = e.toString();
        const span = tracer.startSpan(spanName);
        applyLocationAttrs(span);
        applyReduxAttrs(span, action);
        tracingService.endSpanFailed(span, message);
        throw new Error(e);
      }
    } else {
      result = project(val, index);
    }
    return result;
  });
}
function map(project) {
  return map$1((val, index) => {
    let result = void 0;
    const action = hasType(val) ? val.type : null;
    const tracingService = new TracingService();
    const tracer = tracingService.getTracer();
    if (action && tracer) {
      try {
        const result2 = project(val, index);
        return result2;
      } catch (e) {
        const message = e.toString();
        const span = tracer.startSpan(spanName);
        applyLocationAttrs(span);
        applyReduxAttrs(span, action);
        tracingService.endSpanFailed(span, message);
        throw new Error(e);
      }
    } else {
      result = project(val, index);
    }
    return result;
  });
}
export {
  map,
  mergeMap,
  switchMap
};
//# sourceMappingURL=rxjs.js.map
